// extracted by mini-css-extract-plugin
export var carrierIcon = "_vt-0";
export var carrierLogo = "_vt-1";
export var detailsSection = "_vt-2";